import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateEntityVariableEnum } from '@zaoblako/shared/common/enums/template.entity.variable.enum';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { ListboxModule } from 'primeng/listbox';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  standalone: true,
  selector: 'crm-template-subject-input',
  templateUrl: './template-subject-input.component.html',
  styleUrls: ['./template-subject-input.component.scss'],
  imports: [CommonModule, InputTextComponent, ButtonComponent, ListboxModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateSubjectInputComponent {
  @Input() public subject: string;
  @Output() public subjectChange = new EventEmitter<string>();

  @Input() public isError: boolean;

  public showTemplateOptions = false;
  public templateOptions = Object.values(TemplateEntityVariableEnum).map((option) => '{{' + option + '}}');

  public onTemplateOptionSelect(option: string, input: HTMLElement) {
    this.subject = this.subject ? this.subject + option : option;
    this.subjectChange.emit(this.subject);
    this.showTemplateOptions = false;
    input.focus();
  }
}
